import { merge } from "lodash";
import {
  ElementDefinition,
  ForEachElement,
} from "@easy-email-pro-core/typings";
import { ElementCategory, ElementType } from "@easy-email-pro-core/constants";
import { NodeUtils, createBlock, t } from "@easy-email-pro-core/utils";
import React from "react";
import { BlockRenderer, ContentLeaf } from "@easy-email-pro-core/components";
import { PluginManager } from "@easy-email-pro-core/utils/plugins/PluginManager";

export type IForEach = ElementDefinition<ForEachElement>;

const defaultData: IForEach["defaultData"] = {
  attributes: {},
  data: {
    dataSource: "",
    itemName: "item",

    limit: 999,
  },
};

export const ForEach = createBlock<ForEachElement>({
  get name() {
    return t("ForEach");
  },
  type: ElementType.FOR_EACH,
  category: ElementCategory.UNSET,
  defaultData,
  create(payload) {
    const data: ForEachElement = {
      type: ElementType.FOR_EACH,
      data: {
        ...defaultData.data,
      },
      attributes: {
        ...defaultData.attributes,
      },
      children: [],
    };
    return merge(data, payload);
  },
  render(params) {
    const { node, children, idx } = params;

    const renderContent = PluginManager.generateIterationTemplate(
      { mockQuantity: 1, limit: 999, ...node.data, enabled: true },
      children ||
        node.children.map((child, index) => {
          if (NodeUtils.isTextNode(child)) {
            if (NodeUtils.isTextListElement(node)) {
              return (
                <React.Fragment key={index}>
                  {`<li>`}
                  <ContentLeaf key={index} {...params} node={child} />
                  {`</li>`}
                </React.Fragment>
              );
            }
            return <ContentLeaf key={index} {...params} node={child} />;
          }
          return (
            <BlockRenderer
              key={index}
              {...params}
              idx={idx ? NodeUtils.getChildIdx(idx, index) : null}
              node={child}
            />
          );
        })
    );

    return renderContent;
  },
});
